import { Language } from '../store/languages/types';

export const getDefaultLang = (languages: Language[]): string => {
    return languages.some((x) => x.code === 'en') ? 'en' : 'pl';
};
